/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "gambit": {
            "nested": {
              "api": {
                "nested": {
                  "v1": {
                    "nested": {
                      "common": {
                        "nested": {
                          "Review": {
                            "nested": {
                              "Result": {
                                "values": {
                                  "RESULT_UNSPECIFIED": 0,
                                  "RESULT_ACCEPTED": 1,
                                  "RESULT_ACCEPTED_WITH_FUNDS_HOLD": 2,
                                  "RESULT_ACCEPTED_WITH_FUNDS_HOLD_DAYS_5": 37,
                                  "RESULT_ACCEPTED_WITH_FUNDS_HOLD_DAYS_7": 38,
                                  "RESULT_ACCEPTED_WITH_INSTANT_FUNDING": 43,
                                  "RESULT_ACCEPTED_WITH_PARTIAL_FUNDING": 44,
                                  "RESULT_REJECTED_CHECK_TYPE": 3,
                                  "RESULT_REJECTED_NAME_MISMATCH": 5,
                                  "RESULT_REJECTED_DATE_INVALID": 6,
                                  "RESULT_REJECTED_OTHER": 7,
                                  "RESULT_REJECTED_OTHER_NON_RETRYABLE": 40,
                                  "RESULT_REJECTED_OTHER_RETRYABLE": 41,
                                  "RESULT_REJECTED_ENDORSEMENT_FIXABLE": 8,
                                  "RESULT_REJECTED_ENDORSEMENT_UNFIXABLE": 9,
                                  "RESULT_REJECTED_MICR_CODELINE_OCR_MISMATCH": 32,
                                  "RESULT_REJECTED_CLOSED_ACCOUNT": 33,
                                  "RESULT_REJECTED_FROZEN_ACCOUNT": 39,
                                  "RESULT_REJECTED_MISSING_AUTHORIZATION_CODE": 34,
                                  "RESULT_REJECTED_INSUFFICIENT_FUNDS": 42,
                                  "RESULT_REJECTED_STALE_DATED": 13,
                                  "RESULT_REJECTED_POST_DATED": 14,
                                  "RESULT_REJECTED_ENDORSEMENT_MISSING": 15,
                                  "RESULT_REJECTED_ENDORSEMENT_IRREGULAR": 16,
                                  "RESULT_REJECTED_SIGNATURE_MISSING": 17,
                                  "RESULT_REJECTED_SIGNATURE_IRREGULAR": 18,
                                  "RESULT_REJECTED_NON_CASH_ITEM": 19,
                                  "RESULT_REJECTED_ALTERED_OR_FICTITIOUS": 11,
                                  "RESULT_REJECTED_UNABLE_TO_PROCESS": 20,
                                  "RESULT_REJECTED_ITEM_EXCEEDS_DOLLAR_LIMIT": 21,
                                  "RESULT_REJECTED_NOT_AUTHORIZED": 22,
                                  "RESULT_REJECTED_BRANCH_ACCOUNT_SOLD": 23,
                                  "RESULT_REJECTED_REFER_TO_MAKER": 10,
                                  "RESULT_REJECTED_STOP_PAYMENT_SUSPECT": 24,
                                  "RESULT_REJECTED_POOR_IMAGE_QUALITY": 12,
                                  "RESULT_REJECTED_IMAGE_FAILS_SECURITY_CHECK": 25,
                                  "RESULT_REJECTED_CANNOT_DETERMINE_AMOUNT": 26,
                                  "RESULT_REJECTED_FI_PROHIBITED_IMAGE": 31,
                                  "RESULT_REJECTED_MY_DEPOSIT_PROHIBITED_ITEM": 27,
                                  "RESULT_REJECTED_AMOUNT_MISMATCH": 4,
                                  "RESULT_REJECTED_MISSING_FOR_MOBILE_DEPOSIT_ONLY_WITH_ENDORSEMENT": 28,
                                  "RESULT_REJECTED_ENDORSEMENT_DOES_NOT_MEET_REQUIREMENTS": 29,
                                  "RESULT_REJECTED_IRD_USER_DEFINED": 30,
                                  "RESULT_ESCALATE_HIGH_RISK": 35,
                                  "RESULT_ESCALATE_SECOND_OPINION": 36
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.gambit?.nested?.api?.nested?.v1?.nested?.common?.nested?.Review?.nested?.Result) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Review @ squareup/cash/gambit/api/v1/common/review.proto at 7:1
 */
export const Review = {};
/**
 * next id: 45
 *
 * SOURCE Result @ squareup/cash/gambit/api/v1/common/review.proto at 14:3
 */
Review.Result = $root.lookupEnum('squareup.cash.gambit.api.v1.common.Review.Result').values;